import { Fragment, useEffect } from "react";
import { useBanner } from "../../../providers/BannerProviders";
import Quiltext from "../../../components/elements/Quiltext";
import { Helmet } from "react-helmet-async";

export default function Terms() {
  const { data } = useBanner();
  const termCondition = data?.data?.find(
    (item) => item?.bannerType === "terms"
  );

  useEffect(() => {
    document.title = "Terms & Conditions";
  }, []);

  return (
    <Fragment>
      {termCondition && (
        <Helmet>
          <title>{termCondition.seoTitle}</title>
          <meta
            name="description"
            property="og:description"
            content={termCondition.seoDescription}
          />
          <meta
            name="keywords"
            property="og:keywords"
            content={termCondition.seoKeyword}
          />
          <meta
            name="author"
            property="og:author"
            content={termCondition.seoAuthor}
          />
          <meta
            property="og:image"
            content="https://api.vpeters.iosx.in/storage/siteSetting/1744792455206fdfb9210eeb9358cf800c535.jpeg"
          />
          <meta
            property="og:image:url"
            content="https://api.vpeters.iosx.in/storage/siteSetting/1744792455206fdfb9210eeb9358cf800c535.jpeg"
          />
          <meta
            property="og:image:secure_url"
            content="https://api.vpeters.iosx.in/storage/siteSetting/1744792455206fdfb9210eeb9358cf800c535.jpeg"
          />
        </Helmet>
      )}
      <section className="relative flex w-full pt-40 pb-16 bg-white">
        <div className="w-full sm:max-w-xl md:max-w-2xl lg:max-w-4xl xls:max-w-6xl xl:max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto px-4">
          <div className="relative space-y-10">
            {termCondition?.title && (
              <h1 className="text-4xl font-extrabold">
                {termCondition?.title}
              </h1>
            )}
            {termCondition?.description && (
              <Quiltext description={termCondition?.description} />
            )}
          </div>
        </div>
      </section>
    </Fragment>
  );
}
